export function addZeroWidthSpacesAroundSeparatorCharacters(input: string): string {
    const zeroWidthSpace = '\u200B';
    const separators = ['/', '-'];

    return separators
        .reduce(
            (result, separator) => result.replace(
                new RegExp(separator, 'g'),
                zeroWidthSpace + separator + zeroWidthSpace),
            input);
}
